import { Card, Grid, Icon } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { getTextColorByBackground } from 'utils/ColorUtil'

const AlertPanel = ({
    title,
    icon,
    color,
    comment,
}) => (
    <Card>
        <Grid container>
            <Grid container size={3} sx={{ backgroundColor: color }} alignItems='center' justifyContent='center'>
                <Icon fontSize='large' color={getTextColorByBackground(color)}>
                    {icon}
                </Icon>
            </Grid>
            <Grid container size={9} direction='column' sx={{ padding: '0.35rem 0.65rem' }}>
                <b className='bold'>{title}</b>
                <span>{comment}</span>
            </Grid>
        </Grid>
    </Card>
)

AlertPanel.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    comment: PropTypes.string,
    round: PropTypes.bool,
}

export default AlertPanel